import { Box, Flex, HStack, Link, IconButton, Text, useColorMode } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';

const NAV = [
  { label: 'Projects', to: '/#projects' },
  { label: 'About', to: '/#about' },
];

function NavLink({ to, children }) {
  return (
    <Link as={RouterLink} to={to} fontSize="sm" color="inkDim" _hover={{ color: 'ink', textDecoration: 'none' }}>
      {children}
    </Link>
  );
}

export default function Layout({ children }) {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Box minH="100vh" bg="bg" id="top">
      <Box
        as="header"
        position="sticky"
        top={0}
        zIndex={10}
        bg="bg"
        borderBottom="1px solid"
        borderColor="border"
      >
        <Flex maxW="720px" mx="auto" px={{ base: 5, md: 6 }} h="60px" align="center" justify="space-between">
          <Link as={RouterLink} to="/" fontFamily="heading" fontSize="lg" color="ink" _hover={{ textDecoration: 'none', color: 'accent' }}>
            Michelle Pérez
          </Link>
          <HStack spacing={{ base: 4, sm: 6 }}>
            {NAV.map((n) => <NavLink key={n.to} to={n.to}>{n.label}</NavLink>)}
            <Link href="/MichellePerezCV.pdf" isExternal fontSize="sm" color="inkDim" _hover={{ color: 'ink', textDecoration: 'none' }}>
              CV
            </Link>
            <IconButton
              aria-label={colorMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
              icon={colorMode === 'light' ? <Moon size={17} /> : <Sun size={17} />}
              onClick={toggleColorMode}
              size="sm"
              variant="ghost"
              color="inkDim"
              _hover={{ color: 'ink', bg: 'accentSoft' }}
            />
          </HStack>
        </Flex>
      </Box>

      <Box as="main" maxW="720px" mx="auto" px={{ base: 5, md: 6 }} pt={{ base: 12, md: 16 }} pb={16}>
        {children}
      </Box>

      <Box as="footer" maxW="720px" mx="auto" px={{ base: 5, md: 6 }} pb={10}>
        <Text fontSize="xs" color="inkDim" textAlign="center">
          © {new Date().getFullYear()} Michelle Pérez · Manresa, Barcelona
        </Text>
      </Box>
    </Box>
  );
}
